const value = {
    table: {
      active: 'Активен',
    },
    deleteRowModal: {
      title: 'Удалить профиль',
      message: 'Пользователей, участвующих в проектах, в данном LDAP-профиле нет.',
      confirmationMessage: 'Вы уверены что хотите удалить {{name}} профиль?',
    },
    unableToDeleteRowModal: {
      title: 'Невозможно удалить профиль',
      message1:
        'В данном LDAP-профиле содержатся пользователи, участвующие в проектах. Для удаления профиля {{name}} необходимо отвязать пользователей от проектов.',
      message2: 'Пользователи, участвующие в проектах, в данном LDAP-профиле:',
      inProjects: 'в проектах',
    },
    addModal: {
      title: 'Создание Active Directory',
      useAuthenticationWithThisASByDefault: 'Использовать аутентификацию с использованием данного AD по умолчанию:',
      activateThisConnection: 'Активировать данное подключение:',
      addLink: 'Добавить связь',
      fillBothFields: 'Необходимо заполнить оба поля',
    },
  };

export default value;
